var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('router-link',{attrs:{"to":`/day-wallets/admin/pay-settlement/${_vm.row.id}`}},[_c('i',{staticClass:"fas fa-money-bill"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }